import React from "react";
import { IconProps } from "./IconProps";

const Remove: React.FC<IconProps> = ({
    size = 20,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            {...props}
        >
            <g clipPath="url(#clip0_4049_3364)">
                <path
                    d="M13.3333 4.16659V3.49992C13.3333 2.5665 13.3333 2.09979 13.1517 1.74327C12.9919 1.42966 12.7369 1.1747 12.4233 1.01491C12.0668 0.833252 11.6001 0.833252 10.6667 0.833252H9.33333C8.39991 0.833252 7.9332 0.833252 7.57668 1.01491C7.26308 1.1747 7.00811 1.42966 6.84832 1.74327C6.66667 2.09979 6.66667 2.5665 6.66667 3.49992V4.16659M8.33333 8.74992V12.9166M11.6667 8.74992V12.9166M2.5 4.16659H17.5M15.8333 4.16659V13.4999C15.8333 14.9 15.8333 15.6001 15.5608 16.1349C15.3212 16.6053 14.9387 16.9878 14.4683 17.2274C13.9335 17.4999 13.2335 17.4999 11.8333 17.4999H8.16667C6.76654 17.4999 6.06647 17.4999 5.53169 17.2274C5.06129 16.9878 4.67883 16.6053 4.43915 16.1349C4.16667 15.6001 4.16667 14.9 4.16667 13.4999V4.16659"
                    stroke={color}
                    strokeWidth="1.67"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_4049_3364">
                    <rect width={size} height={size} fill={color} />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Remove;
